/* CASA FACILE — DYNAMIC CARD SYSTEM v20 — 2026-09-06 */
(() => {
  'use strict';

  const ROOT = '#MainContent';
  const COLLECTION_ROUTE_FIXES = {
    'impianto & sicurezza': '/collections/casa-facile-impianto-sicurezza'
  };

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  function normalizeCategory(type, tags, title) {
    const rawType = clean(type);
    const tail = rawType.includes('|') ? clean(rawType.split('|').pop()) : rawType;
    const tagText = Array.isArray(tags) ? tags.join(' ') : clean(tags);
    const haystack = `${tail} ${tagText} ${clean(title)}`.toLowerCase();

    if (/illumin|farett|\bluce\b|led/.test(haystack)) return 'ILLUMINAZIONE LED';
    if (/smart home|domotica|tapparell|termostat/.test(haystack)) return 'DOMOTICA & SMART HOME';
    if (/impianto|sicurezza|salvavita|restart|induzione|quadro/.test(haystack)) return 'IMPIANTO & SICUREZZA';
    if (tail) return tail.toUpperCase();
    return 'CASA FACILE';
  }

  function normalizeCollectionBand(title) {
    const value = clean(title);
    const lower = value.toLowerCase();
    if (lower.includes('domotica') || lower.includes('smart home')) return 'DOMOTICA & SMART HOME';
    if (lower.includes('illuminazione')) return 'ILLUMINAZIONE LED';
    if (lower.includes('impianto') || lower.includes('sicurezza')) return 'IMPIANTO & SICUREZZA';
    if (lower.includes('servizi')) return 'SERVIZI ELETTRICI';
    return value ? value.toUpperCase() : 'CASA FACILE';
  }

  function setBand(card, label) {
    if (!card) return;
    let band = card.querySelector(':scope > .cfm-official-card__topband');
    if (!band) {
      band = document.createElement('div');
      band.className = 'cfm-official-card__topband';
      card.prepend(band);
    }
    band.textContent = clean(label) || 'CASA FACILE';
    card.classList.add('cf-v20-dynamic');
  }

  function setCtaLabel(card, label) {
    const span = card?.querySelector('.cfm-official-card__cta > span');
    if (span && label) span.textContent = label;
  }

  function fixCollections(scope) {
    scope.querySelectorAll('#soluzioni .cfm-official-card--collection').forEach((card) => {
      const title = clean(card.querySelector('h3')?.textContent);
      setBand(card, normalizeCollectionBand(title));

      const key = title.toLowerCase().replace(/\s*\|\s*casa facile$/i, '');
      const safeRoute = COLLECTION_ROUTE_FIXES[key];
      if (safeRoute) {
        card.querySelectorAll('h3 a, .cfm-official-card__cta').forEach((link) => {
          if (link instanceof HTMLAnchorElement) link.setAttribute('href', safeRoute);
        });
      }

      setCtaLabel(card, title.toLowerCase().includes('servizi') ? 'Vedi i servizi' : 'Apri la collezione');
    });
  }

  function readCache(handle) {
    try {
      const raw = sessionStorage.getItem(`cf-v20-product:${handle}`);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  function writeCache(handle, payload) {
    try {
      sessionStorage.setItem(`cf-v20-product:${handle}`, JSON.stringify(payload));
    } catch (_) {}
  }

  async function enrichPackage(card) {
    const title = clean(card.querySelector('h3')?.textContent);
    setBand(card, normalizeCategory('', [], title));
    setCtaLabel(card, 'Scopri il pacchetto');

    const productLink = card.querySelector('h3 a[href*="/products/"]');
    if (!(productLink instanceof HTMLAnchorElement)) return;

    let url;
    try {
      url = new URL(productLink.href, location.origin);
    } catch (_) {
      return;
    }
    const path = url.pathname.replace(/\/$/, '');
    const handle = path.split('/').filter(Boolean).pop();
    if (!handle) return;

    const cached = readCache(handle);
    if (cached) {
      setBand(card, normalizeCategory(cached.type, cached.tags, title));
      return;
    }

    try {
      const response = await fetch(`${path}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const product = await response.json();
      const payload = { type: product.type || '', tags: product.tags || [] };
      writeCache(handle, payload);
      setBand(card, normalizeCategory(payload.type, payload.tags, title));
    } catch (_) {
      /* The title-derived band remains as a safe fallback. */
    }
  }

  function initPackages(scope) {
    const section = scope.querySelector('#pacchetti');
    if (!section) return;
    const cards = [...section.querySelectorAll('.cfm-package-grid > .cfm-official-card')];
    if (!cards.length) return;

    cards.forEach((card) => {
      const title = clean(card.querySelector('h3')?.textContent);
      setBand(card, normalizeCategory('', [], title));
      setCtaLabel(card, 'Scopri il pacchetto');
    });

    const enrichAll = () => cards.forEach((card) => enrichPackage(card));
    if (!('IntersectionObserver' in window)) {
      enrichAll();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      enrichAll();
    }, { rootMargin: '700px 0px' });
    observer.observe(section);
  }

  function init() {
    const scope = document.querySelector(ROOT);
    if (!scope) return;
    fixCollections(scope);
    initPackages(scope);
    document.documentElement.dataset.cfCardBuild = 'v20';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', () => setTimeout(init, 0));
})();
